// extracted by mini-css-extract-plugin
export default {"link":"location_link__hv6QF"};